<div class="btn btn-primary" (click)="add()" style="cursor: pointer;">Add scenario</div>
<table class="table">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Name</th>
      <th scope="col">Department</th>
      <!-- <th scope="col"></th> -->
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of scenarios[0]">
      <td>{{item.id}}</td>
      <td>{{item.name}}</td>
      <td>{{item.department_name}}</td>
      <!-- <td>
        <div class="btn btn-primary" (click)="startstop(item.id)" style="cursor: pointer;"><i class="fa fa-refresh fa-play"></i></div>
    </td> -->
      <td class="text-end">
        <div class="btn btn-primary" (click)="edit(item.id)" style="cursor: pointer;">Edit</div>
      </td>
    </tr>
  </tbody>
</table>